import React from 'react';

const Experience = () => {
  const stats = [
    { number: '50+', label: 'Uzyskanych dotacji', icon: 'fas fa-trophy' },
    { number: '5M+', label: 'PLN Pozyskanych Środków', icon: 'fas fa-coins' },
    { number: '10+', label: 'Lat Doświadczenia', icon: 'fas fa-calendar-alt' },
    { number: '20+', label: 'Programów Grantowych', icon: 'fas fa-list-alt' }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <div className="section-header">
          <h2>Nasze Doświadczenie w Liczbach</h2>
          <p>
            Ponad 10 lat na rynku usług grantowych przekłada się na konkretne rezultaty 
            i zadowolenie naszych klientów.
          </p>
        </div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <i className={stat.icon} style={{ fontSize: '2rem', marginBottom: '16px', color: 'var(--accent-color)' }}></i>
              <span className="stat-number">{stat.number}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
